import React from 'react';
import PropTypes from 'prop-types';

import css from './TickerDate.module.scss';

const TickerDate = ({dateString}) => {
    return (
        <div className={css.tickerDate}>
            <div className={css.dateString}>{dateString}</div>
        </div>
    );
};

if (process.env.NODE_ENV === 'development') {
    TickerDate.propTypes = {
        dateString: PropTypes.string.isRequired
    };
}

export default TickerDate;
